var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHelpWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 15.748,
    height: 16.5,
    viewBox: "0 0 15.748 16.5",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\r\n      .cls-1 {\r\n        fill: none;\r\n        stroke: #fff;\r\n        stroke-linecap: round;\r\n        stroke-linejoin: round;\r\n      }\r\n\r\n      .cls-2 {\r\n        fill: #fff;\r\n      }\r\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_9972",
    "data-name": "Group 9972",
    transform: "translate(21830.5 2219.444)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_7395",
    "data-name": "Path 7395",
    className: "cls-1",
    d: "M4.486.162s.041-1.487.041-1.814c0-2,3.956-2.263,3.956-5.342,0-1.754-1.509-3.161-4-3.161A3.491,3.491,0,0,0,.852-7.4",
    transform: "translate(-21827.309 -2206.26)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_9972-2",
    "data-name": "Group 9972",
    transform: "translate(-21830 -2218.944)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_7394",
    "data-name": "Path 7394",
    className: "cls-1",
    d: "M5.468,14.564a7.409,7.409,0,1,1,3.726,0",
    transform: "translate(0 -0.056)"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_1833",
    "data-name": "Ellipse 1833",
    className: "cls-2",
    cx: 1.159,
    cy: 1.159,
    r: 1.159,
    transform: "translate(6.215 13.683)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHelpWhite);
export default __webpack_public_path__ + "static/media/HelpWhite.816c48836608e0711f7e9f4cda18ba17.svg";
export { ForwardRef as ReactComponent };